import script from "./userTaikenCode.vue?vue&type=script&setup=true&lang=js"
export * from "./userTaikenCode.vue?vue&type=script&setup=true&lang=js"

import "./userTaikenCode.vue?vue&type=style&index=0&id=52315f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52315f70"]])

export default __exports__